import React, { Component } from "react";
import { findDOMNode } from "react-dom";
import { getEmptyImage } from "react-dnd-html5-backend";
import { DragSource } from "react-dnd";
import { getHtmlNodeCenter } from "lib/htmlElements/dimensions";
import { rotatePoint } from "lib/geometry/rotation";
import style from "views/components/Editor/styleSelectionBox.module.css";
import { checkCropHandleProximity } from "lib/croppingUtils";

const ImageCroppingResizeHandlerSource = {
  beginDrag(props, monitor, component) {
    const componentNode = findDOMNode(component);
    // Returning null cancels the drag — the handler unmounted between mount
    // and beginDrag (touch-backend race; see
    // specs/2026-05-13-bug-mobile-dnd-lifecycle-null-dom-sweep.md). Dispatch
    // startCropResizing only after the DOM read succeeds so we don't leave
    // crop-resize state in Redux with no matching endDrag.
    if (!componentNode) return null;

    props.startCropResizing({ pageId: props.selectedItems[0].pageId });

    const selectionBoxNode = componentNode.parentElement;

    const componentNodeCenter = getHtmlNodeCenter(componentNode);
    const selectionBoxNodeCenter = getHtmlNodeCenter(selectionBoxNode);

    const anchorPoint = rotatePoint(
      componentNodeCenter.x,
      componentNodeCenter.y,
      selectionBoxNodeCenter.x,
      selectionBoxNodeCenter.y,
      180
    );

    return {
      handlerInitialPosition: componentNodeCenter,
      anchorPoint: anchorPoint
    };
  },

  endDrag(props, monitor, component) {
    const differenceFromInitialOffset =
      monitor.getDifferenceFromInitialOffset();
    const { handlerInitialPosition, anchorPoint } = monitor.getItem();

    props.finishCropResizing({
      handlerInitialPosition,
      anchorPoint,
      differenceFromInitialOffset
    });
  }
};

/**
 * Specifies the props to inject into your component.
 */
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    differenceFromInitialOffset: monitor.getDifferenceFromInitialOffset()
  };
}

class ImageCroppingResizeHandler extends Component {
  componentDidMount() {
    const { connectDragPreview } = this.props;

    if (connectDragPreview) {
      connectDragPreview(getEmptyImage(), {
        captureDraggingState: true
      });
    }
  }

  render() {
    const {
      connectDragSource,
      designData,
      isCropping,
      position,
      selectedItems,
      zoom
    } = this.props;

    const { x: isXMinimumProximity, y: isYMinimumProximity } =
      checkCropHandleProximity({
        isCropping,
        selectedItems,
        position,
        designData,
        zoom
      });

    return connectDragSource(
      <div
        className={style.dotWrapper}
        data-position={position}
        data-x-proximity={isXMinimumProximity}
        data-y-proximity={isYMinimumProximity}
      >
        <div className={style.dot} ref={this.resizeHandleRef} />
      </div>
    );
  }
}

const ImageCroppingResizeHandlerDraggable = DragSource(
  "IMAGE_CROP_RESIZE_HANDLER",
  ImageCroppingResizeHandlerSource,
  collect
)(ImageCroppingResizeHandler);

const ImageCroppingResizeHandlerDefault = props => {
  return (
    <ImageCroppingResizeHandlerDraggable
      {...props}
      canvasBackgroundHtmlElement={props.canvasBackground}
      startCropResizing={props.startImageCropResizing}
      finishCropResizing={props.finishImageCropResizing}
      selectedItems={props.selectedItems}
      getElement={props.designData.getElement.bind(props.designData)}
      zoom={props.zoom}
      designData={props.designData}
    />
  );
};

export default ImageCroppingResizeHandlerDefault;
